import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PaginationPipe} from './pagination/pagination.pipe';
import { TruncatePipe } from './truncate/truncate.pipe';
import { NullToEmptyStringPipe } from '../text/emptyString.pipe';
import { CallbackPipe } from './callback/callback.pipe';

@NgModule({
    imports: [ 
        CommonModule 
    ],
    declarations: [
        PaginationPipe,
        TruncatePipe,
        NullToEmptyStringPipe,
        CallbackPipe
    ],
    exports: [
        PaginationPipe,
        TruncatePipe,
        NullToEmptyStringPipe,
        CallbackPipe
    ]
})
export class PipesModule { }
